export const SITE_URL = "https://clicksdmp.com";
export const DEFAULT_OG_IMAGE = "https://clicksdmp.com/og-image.jpg";

export const HOME_TITLE = "Fotograf & Videoproduktion Mannheim | Clicks DMP";
export const HOME_DESCRIPTION =
  "Fotos, Videos und Social-Media-Content für Unternehmen und Privatkunden in Mannheim und Rhein-Neckar. Vor Ort gedreht, Antwort innerhalb 1 Stunde.";

export function clip(text: string, max: number): string {
  const t = (text || "").replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  const sp = cut.lastIndexOf(" ");
  return (sp > max * 0.6 ? cut.slice(0, sp) : cut).replace(/[\s,.;:–-]+$/, "") + "…";
}

interface SeoInput {
  title: string;
  description: string;
  /** Path without query or trailing slash, e.g. "/foto" or "" for home. */
  path?: string;
  image?: string | null;
  type?: "website" | "article";
  robots?: string;
}

export function seoHead({ title, description, path, image, type = "website", robots }: SeoInput) {
  const url = path === undefined ? undefined : SITE_URL + (path === "/" ? "" : path);
  const img = image && /^https?:\/\//.test(image) ? image : DEFAULT_OG_IMAGE;
  const meta: Array<Record<string, string>> = [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: img },
    { property: "og:type", content: type },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: img },
  ];
  if (url) meta.push({ property: "og:url", content: url });
  if (robots) meta.push({ name: "robots", content: robots });
  return {
    meta,
    links: url ? [{ rel: "canonical", href: url }] : [],
  };
}

export const noindexHead = () => ({
  meta: [{ title: "Clicks DMP" }, { name: "robots", content: "noindex, nofollow" }],
});
